import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HiRefresh } from "react-icons/hi";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdArrowDropdown } from "react-icons/io";
import axios from "axios";
import io from "socket.io-client";
import { useDbContext } from "../../../../context/DbContext";
import { AuthContext } from "../../../../context/AuthContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../../app/permissionsSlice";
import ActionToolbar from "../../../NavBars/ActionToolbar";
import SherComboBox from "../../../ComboBoxes/SherComboBox";
import RenameLedger from "../../../RenameLedger/RenameLedger";
import WindowHeader from "../../../Layout/WindowHeader/WindowHeader";
import headeLogo from "../../../../assets/images/shersoftnavLogo.png";
import { useActiveFyLimits } from "../../../../utils/fyDateValidation";

function LedgerRegMob({ onClose, val, underVal }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const { agentCode } = useContext(AuthContext);
  const [showRenameLedModal, setShowRenameLedModal] = useState(false);
  const permissions = useSelector(selectMenuPermissions);
  const navigate = useNavigate();

  const [userType, setuserType] = useState("");
  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
    }
  }, []);

  const { minDate, maxDate, isDateInFy } = useActiveFyLimits();

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const today = getCurrentDate();

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const [activeTab, setActiveTab] = useState("account");
  const [dataFound, setDataFound] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [debitAmount, setDebitAmount] = useState("");
  const [creditAmount, setCreditAmount] = useState("");
  const [findSuccess, setFindSuccess] = useState(false);

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);

  const [routeOptions, setRouteOptions] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [subGroupOptions, setSubGroupOptions] = useState([]);

  const [stateOptions] = useState([
    { label: "Andhra Pradesh", value: "37" },
    { label: "Arunachal Pradesh", value: "12" },
    { label: "Assam", value: "18" },
    { label: "Bihar", value: "10" },
    { label: "Chhattisgarh", value: "22" },
    { label: "Goa", value: "30" },
    { label: "Gujarat", value: "24" },
    { label: "Haryana", value: "06" },
    { label: "Himachal Pradesh", value: "02" },
    { label: "Jharkhand", value: "20" },
    { label: "Karnataka", value: "29" },
    { label: "Kerala", value: "32" },
    { label: "Madhya Pradesh", value: "23" },
    { label: "Maharashtra", value: "27" },
    { label: "Manipur", value: "14" },
    { label: "Meghalaya", value: "17" },
    { label: "Mizoram", value: "15" },
    { label: "Nagaland", value: "13" },
    { label: "Odisha", value: "21" },
    { label: "Punjab", value: "03" },
    { label: "Rajasthan", value: "08" },
    { label: "Sikkim", value: "11" },
    { label: "Tamil Nadu", value: "33" },
    { label: "Telangana", value: "36" },
    { label: "Tripura", value: "16" },
    { label: "Uttar Pradesh", value: "09" },
    { label: "Uttarakhand", value: "05" },
    { label: "West Bengal", value: "19" },
  ]);

  const [stateCodeOptions] = useState([
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },
    { label: "08", value: "08" },
    { label: "09", value: "09" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
    { label: "32", value: "32" },
    { label: "33", value: "33" },
    { label: "34", value: "34" },
    { label: "35", value: "35" },
    { label: "36", value: "36" },
    { label: "37", value: "37" },
    { label: "38", value: "38" },
  ]);

  const [dayOptions] = useState([
    { label: "Sunday", value: 1 },
    { label: "Monday", value: 2 },
    { label: "Tuesday", value: 3 },
    { label: "Wednesday", value: 4 },
    { label: "Thursday", value: 5 },
    { label: "Friday", value: 6 },
    { label: "Saturday", value: 7 },
  ]);

  const [salesRateOptions] = useState([
    { label: "MRP", value: 1 },
    { label: "RETAIL", value: 2 },
    { label: "SPRETAIL", value: 3 },
    { label: "WHOLESALE", value: 4 },
    { label: "BRANCH", value: 5 },
  ]);

  const [customerNatureOptions] = useState([
    { label: "EXCELLENT", value: 1 },
    { label: "GOOD", value: 2 },
    { label: "AVERAGE", value: 3 },
  ]);

  const nameInputRef = useRef(null);
  const underInputRef = useRef(null);
  const salesmanInputRef = useRef(null);
  const add1InputRef = useRef(null);
  const add2InputRef = useRef(null);
  const add3InputRef = useRef(null);
  const add4InputRef = useRef(null);
  const gstInputRef = useRef(null);
  const CpersonInputRef = useRef(null);
  const pincodeInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const mobInputRef = useRef(null);
  const debitAmountInputRef = useRef(null);
  const creditAmountInputRef = useRef(null);
  const saveBtnRef = useRef(null);
  const editButtonRef = useRef(null);
  const dateRef = useRef(null);

  const routeInputRef = useRef(null);
  const stateInputRef = useRef(null);
  const stateCodeInputRef = useRef(null);
  const panInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const subGroupInputRef = useRef(null);
  const orderDayInputRef = useRef(null);
  const deliveryDayInputRef = useRef(null);
  const salesRateInputRef = useRef(null);
  const secondNameInputRef = useRef(null);
  const commissionInputRef = useRef(null);
  const cAmountInputRef = useRef(null);
  const cDaysInputRef = useRef(null);
  const maxDiscountInputRef = useRef(null);
  const customerNatureInputRef = useRef(null);
  const msmeUdyamInputRef = useRef(null);
  const msmeTypeInputRef = useRef(null);
  const msmeAgreementInputRef = useRef(null);
  const msmeBusinessTypeInputRef = useRef(null);
  const areaInputRef = useRef(null);

  const [formData, setFormData] = useState({
    lr_Name: "" || val,
    ledcode: "",
    lr_Under: "" || underVal,
    lh_id: "",
    lr_Address1: "",
    lr_Address2: "",
    lr_Address3: "",
    lr_Address4: "",
    lr_Area: "",
    lr_AreaId: "",
    lr_Route: "",
    lr_RouteId: "",
    lr_State: "",
    lr_StateCode: "",
    lr_Pincode: "",
    lr_Contactperson: "",
    lr_Mobile: "",
    lr_Gstno: "",
    lr_Email: "",
    lr_Pan: "",
    lr_SalesMan: "",
    lr_empid: "",
    lr_SecondName: "",
    lr_Location: "",
    lr_LocationId: "",
    lr_SubGroup: "",
    lr_SubGroupId: "",
    lr_OrderDate: "",
    lr_OrderDateId: "",
    lr_DeliveryDate: "",
    lr_DeliveryDateId: "",
    lr_SalesRate: "",
    lr_SalesRateId: "",
    lr_CustomerNature: "",
    lr_CAmount: "",
    lr_CDays: "",
    lr_CommissionPer: "",
    lr_MaxDiscount: "",
    lr_Active: 1,
    lr_CostCenter: 0,
    lr_MsmeEnabled: 0,
    lr_MsmeUdyamNo: "",
    lr_MsmeType: "",
    lr_MsmeAgreement: "",
    lr_MsmeBusinessType: "",
    lr_debit: "0.000",
    lr_credit: "0.000",
    lr_date: today,
  });

  const emitDataUpdate = () => {
    const socket = io(apiBaseUrl);
    socket.emit("dataUpdated");
    socket.disconnect();
  };

  const handleClear = () => {
    [
      nameInputRef,
      underInputRef,
      routeInputRef,
      stateInputRef,
      stateCodeInputRef,
      salesmanInputRef,
      locationInputRef,
      subGroupInputRef,
      orderDayInputRef,
      deliveryDayInputRef,
      salesRateInputRef,
      customerNatureInputRef,
      areaInputRef,
    ].forEach((ref) => ref.current?.clearInput?.());

    setFormData({
      lr_Name: "",
      ledcode: "",
      lr_Under: "",
      lh_id: "",
      lr_Address1: "",
      lr_Address2: "",
      lr_Address3: "",
      lr_Address4: "",
      lr_Area: "",
      lr_AreaId: "",
      lr_Route: "",
      lr_RouteId: "",
      lr_State: "",
      lr_StateCode: "",
      lr_Pincode: "",
      lr_Contactperson: "",
      lr_Mobile: "",
      lr_Gstno: "",
      lr_Email: "",
      lr_Pan: "",
      lr_SalesMan: "",
      lr_empid: "",
      lr_SecondName: "",
      lr_Location: "",
      lr_LocationId: "",
      lr_SubGroup: "",
      lr_SubGroupId: "",
      lr_OrderDate: "",
      lr_OrderDateId: "",
      lr_DeliveryDate: "",
      lr_DeliveryDateId: "",
      lr_SalesRate: "",
      lr_SalesRateId: "",
      lr_CustomerNature: "",
      lr_CAmount: "",
      lr_CDays: "",
      lr_CommissionPer: "",
      lr_MaxDiscount: "",
      lr_Active: 1,
      lr_CostCenter: 0,
      lr_MsmeEnabled: 0,
      lr_MsmeUdyamNo: "",
      lr_MsmeType: "",
      lr_MsmeAgreement: "",
      lr_MsmeBusinessType: "",
      lr_debit: "0.000",
      lr_credit: "0.000",
      lr_date: getCurrentDate(),
    });

    setDebitAmount("");
    setCreditAmount("");
    setFindSuccess(false);
    fetchLednamesNames();
    setDataFound(false);

    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);

    setTimeout(() => {
      nameInputRef.current?.focus?.();
    }, 0);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    handleClear();
    try {
      await Promise.all([
        fetchLednamesNames(),
        fetchparent(),
        fetchOtherRegOptions(),
        fetchEmployeeNames(),
      ]);
    } catch (error) {
      console.error("Error refreshing data:", error.message);
    }
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };

  const fieldRefMap = {
    lr_Name: nameInputRef,
    lr_Under: underInputRef,
    lr_Address1: add1InputRef,
    lr_Address2: add2InputRef,
    lr_Address3: add3InputRef,
    lr_Address4: add4InputRef,
    lr_Pincode: pincodeInputRef,
    lr_Area: areaInputRef,
    lr_Route: routeInputRef,
    lr_State: stateInputRef,
    lr_StateCode: stateCodeInputRef,
    lr_Mobile: mobInputRef,
    lr_SalesMan: salesmanInputRef,
    lr_Pan: panInputRef,
    lr_Email: emailInputRef,
    lr_Gstno: gstInputRef,
    lr_Location: locationInputRef,
    lr_SubGroup: subGroupInputRef,
    lr_OrderDay: orderDayInputRef,
    lr_DeliveryDay: deliveryDayInputRef,
    lr_SalesRate: salesRateInputRef,
    lr_Contactperson: CpersonInputRef,
    lr_SecondName: secondNameInputRef,
    lr_CommissionPer: commissionInputRef,
    lr_CAmount: cAmountInputRef,
    lr_CDays: cDaysInputRef,
    lr_MaxDiscount: maxDiscountInputRef,
    lr_CustomerNature: customerNatureInputRef,
    lr_debit: debitAmountInputRef,
    lr_credit: creditAmountInputRef,
    lr_MsmeUdyamNo: msmeUdyamInputRef,
    lr_MsmeType: msmeTypeInputRef,
    lr_MsmeAgreement: msmeAgreementInputRef,
    lr_MsmeBusinessType: msmeBusinessTypeInputRef,
  };

  const fieldTabMap = {
    lr_Name: "account",
    lr_Under: "account",
    lr_Address1: "address",
    lr_Address2: "address",
    lr_Address3: "address",
    lr_Address4: "address",
    lr_Pincode: "address",
    lr_Area: "address",
    lr_Route: "address",
    lr_State: "address",
    lr_StateCode: "address",
    lr_Mobile: "address",
    lr_SalesMan: "address",
    lr_Pan: "address",
    lr_Email: "address",
    lr_Gstno: "address",
    lr_Location: "address",
    lr_SubGroup: "address",
    lr_OrderDay: "address",
    lr_DeliveryDay: "address",
    lr_SalesRate: "address",
    lr_Contactperson: "address",
    lr_SecondName: "address",
    lr_CommissionPer: "address",
    lr_CAmount: "address",
    lr_CDays: "address",
    lr_MaxDiscount: "address",
    lr_CustomerNature: "address",
    lr_debit: "openingbalance",
    lr_credit: "openingbalance",
    lr_MsmeUdyamNo: "msme",
    lr_MsmeType: "msme",
    lr_MsmeAgreement: "msme",
    lr_MsmeBusinessType: "msme",
  };

  const fieldOrder = [
    "lr_Name",
    "lr_Under",
    "lr_Address1",
    "lr_Address2",
    "lr_Address3",
    "lr_Address4",
    "lr_Pincode",
    "lr_Area",
    "lr_Route",
    "lr_State",
    "lr_StateCode",
    "lr_Mobile",
    "lr_SalesMan",
    "lr_Pan",
    "lr_Email",
    "lr_Gstno",
    "lr_Location",
    "lr_SubGroup",
    "lr_OrderDay",
    "lr_DeliveryDay",
    "lr_SalesRate",
    "lr_Contactperson",
    "lr_SecondName",
    "lr_CommissionPer",
    "lr_CAmount",
    "lr_CDays",
    "lr_MaxDiscount",
    "lr_CustomerNature",
    "lr_debit",
    "lr_credit",
    "lr_MsmeUdyamNo",
    "lr_MsmeType",
    "lr_MsmeAgreement",
    "lr_MsmeBusinessType",
  ];

  const focusFieldById = (id, attempt = 0) => {
    const ref = fieldRefMap[id];
    const tab = fieldTabMap[id];
    if (!ref) return;

    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }

    requestAnimationFrame(() => {
      if (ref.current && typeof ref.current.focus === "function") {
        ref.current.focus();
      } else if (attempt < 15) {
        setTimeout(() => focusFieldById(id, attempt + 1), 25);
      }
    });
  };

  const focusSaveOrEdit = () => {
    const saveEnabled = !(dataFound || isLoading || saveDisabled);
    const editEnabled = !(!dataFound || editDisabled || isLoading);

    if (saveEnabled && saveBtnRef.current) {
      saveBtnRef.current.focus();
    } else if (editEnabled && editButtonRef.current) {
      editButtonRef.current.focus();
    }
  };

  const handleEnterNav = (event, currentId) => {
    if (event.key !== "Enter" && event.key !== "Return") return;
    event.preventDefault();

    const idx = fieldOrder.indexOf(currentId);
    if (idx === -1) return;

    const nextId = fieldOrder[idx + 1];
    if (nextId) {
      focusFieldById(nextId);
    } else {
      focusSaveOrEdit();
    }
  };

  const handleSubmit = async () => {
    setSaveDisabled(true);

    if (formData.lr_Under && !formData.lh_id) {
      const matched = under.find(
        (opt) =>
          opt.label?.toLowerCase() === formData.lr_Under.trim().toLowerCase() ||
          opt.value?.toString() === formData.lr_Under.trim()
      );
      if (matched) {
        formData.lh_id = matched.value;
        formData.lr_Under = matched.label;
      }
    }

    if (Lednames.some(item => item.label === formData.lr_Name || item.value === formData.ledcode)) {
      alert("Duplicate Ledger Name");
      setSaveDisabled(false);
      return;
    }
    if (!formData.lr_Name || !formData.lr_Under) {
      alert("Enter Data Correctly");
      setIsLoading(false);
      setSaveDisabled(false);
      return;
    }

    const isValidUnder = under.some(opt => opt.value == formData.lh_id || opt.label == formData.lr_Under || opt.value == formData.lr_Under);
    if (!isValidUnder) {
      alert("Invalid Under (Group) selected");
      setIsLoading(false);
      setSaveDisabled(false);
      return;
    }

    if (formData.lr_Mobile.length !== 10 && formData.lr_Mobile.length !== 0) {
      alert("Invalid Mobile Number.");
      setIsLoading(false);
      setSaveDisabled(false);
      return;
    }
    if (formData.lr_Email && !validateEmail(formData.lr_Email)) {
      alert("Invalid email address");
      setIsLoading(false);
      setSaveDisabled(false);
      return;
    }
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${apiBaseUrl}/main/insertledger/${dbCode}`,
        formData,
      );

      if (response.status === 200) {
        alert("Ledger registered");
        if (val) {
          onClose();
        }
        handleClear();
        emitDataUpdate();
        setIsLoading(false);
      } else {
        console.error("Error submitting data:", response.data);
        setIsLoading(false);
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setIsLoading(false);
      setSaveDisabled(false);
    }
  };

  const handleUpdate = async () => {
    if (formData.lr_Under && !formData.lh_id) {
      const matched = under.find(
        (opt) =>
          opt.label?.toLowerCase() === formData.lr_Under.trim().toLowerCase() ||
          opt.value?.toString() === formData.lr_Under.trim()
      );
      if (matched) {
        formData.lh_id = matched.value;
        formData.lr_Under = matched.label;
      }
    }

    if (!formData.lr_Name || !formData.lr_Under) {
      alert("Enter Data Correctly");
      return;
    }

    const isValidUnder = under.some(opt => opt.value == formData.lh_id || opt.label == formData.lr_Under || opt.value == formData.lr_Under);
    if (!isValidUnder) {
      alert("Invalid Under (Group) selected");
      setIsLoading(false);
      return;
    }

    if (
      formData.lr_Mobile &&
      formData.lr_Mobile.length !== 10 &&
      formData.lr_Mobile.length !== 0
    ) {
      alert("Invalid Mobile Number.");
      setIsLoading(false);
      return;
    }
    if (formData.lr_Email && !validateEmail(formData.lr_Email)) {
      alert("Invalid email address");
      setIsLoading(false);
      return;
    }
    try {
      const response = await axios.post(
        `${apiBaseUrl}/main/spupdateledger/${dbCode}`,
        formData,
      );

      if (response.status === 200) {
        alert("Ledger Updated");
        emitDataUpdate();
        handleClear();
      } else {
        console.error("Error updating data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const [Lednames, setLednames] = useState([]);
  useEffect(() => {
    if (dbCode) {
      fetchLednamesNames();
      fetchparent();
      fetchOtherRegOptions();
      fetchEmployeeNames();
    }

    const socket = io(apiBaseUrl);
    socket.on("dataUpdated", () => {
      if (dbCode) {
        fetchLednamesNames();
        fetchparent();
      }
    });

    socket.on("GroupUpdated", () => {
      if (dbCode) {
        fetchparent();
      }
    });

    socket.on("OtherRegistrationUpdated", () => {
      if (dbCode) {
        fetchOtherRegOptions();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode]);

  const [under, setUnder] = useState([]);

  useEffect(() => {
    if (underVal && under.length > 0) {
      const matched = under.find(
        (item) =>
          item.label?.toLowerCase() === underVal.toLowerCase() ||
          item.value?.toString() === underVal.toString()
      );
      if (matched) {
        setFormData((prev) => ({
          ...prev,
          lr_Under: matched.label,
          lh_id: matched.value,
        }));
      }
    }
  }, [underVal, under]);

  const fetchLednamesNames = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgernames/${dbCode}`,
      );
      const ledDetails = response.data;
      const lednames = ledDetails.map((item) => ({
        label: item.LedName,
        value: item.Ledcode,
      }));
      setLednames(lednames);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };

  const fetchparent = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgerheads/${dbCode}`,
      );
      const parDetails = response.data;
      const under = parDetails.map((item) => ({
        label: item.lh_name,
        value: item.lh_id,
      }));
      setUnder(under);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };

  const fetchOtherRegOptions = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/otherregistration/getoptions/${dbCode}`);
      const data = response.data || [];

      const routes = data
        .filter(item => item.Type === "Route" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      const areas = data
        .filter(item => item.Type === "City" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      const branches = data
        .filter(item => item.Type === "Location" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      const subgroups = data
        .filter(item => item.Type === "SubGroup" && item.Active !== 0)
        .map(item => ({ label: item.Name, value: Number(item.Auto ?? item.auto ?? 0) }));

      setRouteOptions(routes);
      setAreaOptions(areas);
      setLocationOptions(branches);
      setSubGroupOptions(subgroups);
    } catch (error) {
      console.error("Error fetching other registration options:", error.message);
    }
  };

  const handleCreateOtherRegOption = async (name, type) => {
    const labelType = type === 'City' ? 'Area' : 'Route';
    if (!window.confirm(`Do you want to create ${labelType} "${name}"?`)) {
      return;
    }
    try {
      const response = await axios.post(
        `${apiBaseUrl}/otherregistration/insert/${dbCode}`,
        {
          name: name,
          description: `Created via Ledger Registration`,
          type: type,
          takeuser: agentCode || 0,
        }
      );
      if (response.data.success) {
        alert(`${labelType} "${name}" created successfully!`);
        
        const getRes = await axios.get(`${apiBaseUrl}/otherregistration/getoptions/${dbCode}`);
        const data = getRes.data || [];
        const matchedItem = data.find(
          item => item.Type === type && item.Name?.toLowerCase() === name.toLowerCase()
        );
        
        if (matchedItem) {
          if (type === 'City') {
            setFormData((prev) => ({
              ...prev,
              lr_Area: matchedItem.Name,
              lr_AreaId: Number(matchedItem.Auto ?? matchedItem.auto ?? 0),
            }));
          } else if (type === 'Route') {
            setFormData((prev) => ({
              ...prev,
              lr_Route: matchedItem.Name,
              lr_RouteId: Number(matchedItem.Auto ?? matchedItem.auto ?? 0),
            }));
          }
        }
        await fetchOtherRegOptions();
      } else {
        alert(response.data.message || `Failed to create ${labelType}.`);
      }
    } catch (error) {
      console.error("Error creating registration option:", error.message);
      alert("Failed to create option.");
    }
  };

  const [employeeNames, setEmployeeNames] = useState([]);
  const fetchEmployeeNames = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchReg_empname/${dbCode}`,
      );
      const empNames = response.data.map((item) => ({
        label: item.name,
        value: item.Auto,
      }));
      setEmployeeNames(empNames);
    } catch (error) {
      console.error("Error fetching employee names:", error.message);
    }
  };

  const fetchLedgerDetails = async (name, code) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/main/spledgerFindbyname/${dbCode}`,
        { lr_Name: name, ledcode: code },
      );

      if (response.status === 200) {
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);

        const foundData = response.data[0];
        if (!foundData) return;

        fetchExist(foundData.Ledcode);

        const formattedDate = new Date(foundData.date)
          .toISOString()
          .split("T")[0];

        setFormData({
          ...formData,
          lr_Name: foundData.LedName,
          ledcode: foundData.Ledcode,
          lr_Under: foundData.parentname,
          lh_id: foundData.lh_id,
          lr_Address1: foundData.add1,
          lr_Address2: foundData.add2,
          lr_Address3: foundData.add3,
          lr_Address4: foundData.add4,
          lr_Area: foundData.Area || "",
          lr_AreaId: foundData.city || "",
          lr_Route: foundData.Route || "",
          lr_RouteId: foundData.route || "",
          lr_State: foundData.state,
          lr_StateCode: foundData.stateCode,
          lr_Pincode: foundData.PinNo,
          lr_Contactperson: foundData.CPerson,
          lr_Mobile: foundData.Mobile,
          lr_Gstno: foundData.gstno,
          lr_Email: foundData.Email,
          lr_Pan: foundData.pan,
          lr_SalesMan: foundData.SalesMan,
          lr_empid: foundData.SalesMan,
          lr_SecondName: foundData.SecondName,
          lr_Location: "",
          lr_LocationId: foundData.Location,
          lr_SubGroup: "",
          lr_SubGroupId: foundData.SubGroup,
          lr_OrderDate: "",
          lr_OrderDateId: foundData.OrderDate,
          lr_DeliveryDate: "",
          lr_DeliveryDateId: foundData.DeliveryDate,
          lr_SalesRate: "",
          lr_SalesRateId: foundData.SalesRate,
          lr_CustomerNature: foundData.CustomerNature || "",
          lr_CommissionPer: foundData.CommissionPer !== undefined ? foundData.CommissionPer : "",
          lr_MaxDiscount: foundData.maxDiscount !== undefined ? foundData.maxDiscount : "",
          lr_CAmount: foundData.CAmount,
          lr_CDays: foundData.CDays,
          lr_Active: foundData.Active,
          lr_CostCenter: foundData.CostCenter,
          lr_MsmeEnabled: foundData.MsmeEnabled,
          lr_MsmeUdyamNo: foundData.MsmeUdyamNo,
          lr_MsmeType: foundData.MsmeType,
          lr_MsmeAgreement: foundData.MsmeAgreement,
          lr_MsmeBusinessType: foundData.MsmeBusinessType,
          lr_debit: foundData.atDebitAmount,
          lr_credit: foundData.atCreditAmount,
          lr_date: formattedDate,
        });

        setDataFound(true);
      } else {
        console.error("Error retrieving data:", response.data);
        setDataFound(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setDataFound(false);
    }
  };

  const handleFindByname = async () => {
    await fetchLedgerDetails(formData.lr_Name, formData.ledcode);
  };

  const handleFindBygst = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgerFindbygstNo/${formData.lr_Gstno}/${dbCode}`,
      );

      if (response.status === 200) {
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
        const foundData = response.data[0];
        fetchExist(foundData.Ledcode);

        const formattedDate = new Date(foundData.date)
          .toISOString()
          .split("T")[0];
        setFormData({
          ...formData,
          lr_Name: foundData.LedName,
          ledcode: foundData.Ledcode,
          lr_Under: foundData.parentname,
          lh_id: foundData.lh_id,
          lr_Address1: foundData.add1,
          lr_Address2: foundData.add2,
          lr_Address3: foundData.add3,
          lr_Address4: foundData.add4,
          lr_Area: foundData.Area || "",
          lr_AreaId: foundData.city || "",
          lr_Route: foundData.Route || "",
          lr_RouteId: foundData.route || "",
          lr_State: foundData.state,
          lr_StateCode: foundData.stateCode,
          lr_Pincode: foundData.PinNo,
          lr_Contactperson: foundData.CPerson,
          lr_Mobile: foundData.Mobile,
          lr_Gstno: foundData.gstno,
          lr_Email: foundData.Email,
          lr_Pan: foundData.pan,
          lr_SalesMan: foundData.SalesMan,
          lr_empid: foundData.SalesMan,
          lr_SecondName: foundData.SecondName,
          lr_Location: "",
          lr_LocationId: foundData.Location,
          lr_SubGroup: "",
          lr_SubGroupId: foundData.SubGroup,
          lr_OrderDate: "",
          lr_OrderDateId: foundData.OrderDate,
          lr_DeliveryDate: "",
          lr_DeliveryDateId: foundData.DeliveryDate,
          lr_SalesRate: "",
          lr_SalesRateId: foundData.SalesRate,
          lr_CustomerNature: foundData.CustomerNature || "",
          lr_CommissionPer: foundData.CommissionPer !== undefined ? foundData.CommissionPer : "",
          lr_MaxDiscount: foundData.maxDiscount !== undefined ? foundData.maxDiscount : "",
          lr_CAmount: foundData.CAmount,
          lr_CDays: foundData.CDays,
          lr_Active: foundData.Active,
          lr_CostCenter: foundData.CostCenter,
          lr_MsmeEnabled: foundData.MsmeEnabled,
          lr_MsmeUdyamNo: foundData.MsmeUdyamNo,
          lr_MsmeType: foundData.MsmeType,
          lr_MsmeAgreement: foundData.MsmeAgreement,
          lr_MsmeBusinessType: foundData.MsmeBusinessType,
          lr_debit: foundData.atDebitAmount,
          lr_credit: foundData.atCreditAmount,
          lr_date: formattedDate,
        });
        setDataFound(true);
      } else {
        console.error("Error retrieving data:", response.data);
        setDataFound(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setDataFound(false);
    }
  };

  const handleFindBymob = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/spledgerFindbymob/${formData.lr_Mobile}/${dbCode}`,
      );

      if (response.status === 200) {
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
        const foundData = response.data[0];
        fetchExist(foundData.Ledcode);

        const formattedDate = new Date(foundData.date)
          .toISOString()
          .split("T")[0];

        setFormData({
          ...formData,
          lr_Name: foundData.LedName,
          ledcode: foundData.Ledcode,
          lr_Under: foundData.parentname,
          lh_id: foundData.lh_id,
          lr_Address1: foundData.add1,
          lr_Address2: foundData.add2,
          lr_Address3: foundData.add3,
          lr_Address4: foundData.add4,
          lr_Area: foundData.Area || "",
          lr_AreaId: foundData.city || "",
          lr_Route: foundData.Route || "",
          lr_RouteId: foundData.route || "",
          lr_State: foundData.state,
          lr_StateCode: foundData.stateCode,
          lr_Pincode: foundData.PinNo,
          lr_Contactperson: foundData.CPerson,
          lr_Mobile: foundData.Mobile,
          lr_Gstno: foundData.gstno,
          lr_Email: foundData.Email,
          lr_Pan: foundData.pan,
          lr_SalesMan: foundData.SalesMan,
          lr_empid: foundData.SalesMan,
          lr_SecondName: foundData.SecondName,
          lr_Location: "",
          lr_LocationId: foundData.Location,
          lr_SubGroup: "",
          lr_SubGroupId: foundData.SubGroup,
          lr_OrderDate: "",
          lr_OrderDateId: foundData.OrderDate,
          lr_DeliveryDate: "",
          lr_DeliveryDateId: foundData.DeliveryDate,
          lr_SalesRate: "",
          lr_SalesRateId: foundData.SalesRate,
          lr_CustomerNature: foundData.CustomerNature || "",
          lr_CommissionPer: foundData.CommissionPer !== undefined ? foundData.CommissionPer : "",
          lr_MaxDiscount: foundData.maxDiscount !== undefined ? foundData.maxDiscount : "",
          lr_CAmount: foundData.CAmount,
          lr_CDays: foundData.CDays,
          lr_Active: foundData.Active,
          lr_CostCenter: foundData.CostCenter,
          lr_MsmeEnabled: foundData.MsmeEnabled,
          lr_MsmeUdyamNo: foundData.MsmeUdyamNo,
          lr_MsmeType: foundData.MsmeType,
          lr_MsmeAgreement: foundData.MsmeAgreement,
          lr_MsmeBusinessType: foundData.MsmeBusinessType,
          lr_debit: foundData.atDebitAmount,
          lr_credit: foundData.atCreditAmount,
          lr_date: formattedDate,
        });
        setDataFound(true);
      } else {
        console.error("Error retrieving data:", response.data);
        setDataFound(false);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setDataFound(false);
    }
  };

  const [countExist, setcountExist] = useState("");

  const fetchExist = async (code) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/schUsedEntry/${code}/${dbCode}`,
      );
      setcountExist(response.data[0].CountExists);
    } catch (error) {
      console.error("Error fetching entry status:", error.message);
    }
  };

  const handleDelete = async () => {
    if (countExist > 0) {
      alert("Entry used");
      return;
    }

    if (formData.lr_Name === "") {
      alert("invalid Name");
      return;
    }
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/spdeleteLedger/${formData.ledcode}/${dbCode}`,
      );
      if (response.status === 200) {
        alert("Account Deleted ");
        handleClear();
        emitDataUpdate();
      } else {
        console.error("Error deleting data:", response.data);
        alert("Error deleting data");
      }
    } catch (error) {
      console.error("Error:", error.message);
      alert("Error deleting data");
    }
  };

  const openRenameLedger = () => {
    if (!formData.lr_Name) return;
    setShowRenameLedModal(true);
  };

  const updateNavRefs = (refs) => {
    if (refs.saveBtnRef) {
      saveBtnRef.current = refs.saveBtnRef.current;
    } else if (refs.saveButtonRef) {
      saveBtnRef.current = refs.saveButtonRef.current;
    }
    if (refs.editButtonRef) {
      editButtonRef.current = refs.editButtonRef.current;
    }
  };

  const accountSettings = [
    { id: "costCenter", label: "Cost Center", field: "lr_CostCenter" },
    { id: "active", label: "Active", field: "lr_Active" },
  ];

  return (
    <div className="fixed inset-0 w-full h-full bg-[#f0f0f0] flex flex-col pointer-events-auto z-[10000] overflow-y-auto font-sans">
      <WindowHeader
        title="Ledger Registration"
        logo={headeLogo}
        onClose={onClose}
        className="bg-[rgb(0,8,169)] rounded-none"
        closeBtnClassName="w-6 h-6 border-none rounded-none mr-2"
      />
      {/* Action Toolbar */}
      <div className="w-full flex-shrink-0">
        <ActionToolbar
          width="100%"
          height="auto"
          bgColor="#EAF0FC"
          showSave={true}
          showPrint={false}
          showClear={true}
          showFind={true}
          showEdit={true}
          showDelete={true}
          showExit={true}
          showNavigation={false}
          saveDisabled={dataFound || isLoading || saveDisabled}
          editDisabled={!dataFound || editDisabled || isLoading}
          deleteDisabled={!dataFound || deleteDisabled || isLoading}
          dataFound={dataFound}
          permissions={permissions}
          permissionKey="ledgerReg"
          onSave={handleSubmit}
          onClear={handleClear}
          onFind={handleFindByname}
          onEdit={handleUpdate}
          onDelete={handleDelete}
          onExit={() => navigate("/home")}
          onRefsUpdate={updateNavRefs}
        />
      </div>

      {/* Tab Navigation */}
      <div className="w-full flex-shrink-0 border-b border-[#b8cce0] bg-white">
        <div className="flex justify-between px-1 pt-2.5 overflow-x-auto gap-1">
          {["Account", "Address", "Opening Balance", "MSME"].map((tab) => {
            const key = tab.toLowerCase().replace(" ", "");
            return (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`px-4 py-2.5 text-xs font-bold border-none cursor-pointer transition-all duration-150 flex-1 text-center whitespace-nowrap
                  ${activeTab === key
                    ? "bg-[#E8EEF8] text-[#0008a9] rounded-t-lg border-b-4 border-[#0008a9]"
                    : "bg-transparent text-[#1a2e4a] hover:bg-[#1a2e4a14]"
                  }`}
              >
                {tab}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content Body */}
      <div className="flex-1 p-4 bg-[#f8fafc] overflow-y-auto pb-20">
        {activeTab === "account" && (
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#0008a9] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
                  <path d="M8 7h6M8 11h8" />
                </svg>
              </div>
              <div className="flex flex-col">
                <h2 className="text-sm font-bold text-gray-900 m-0">Account Details</h2>
                <span className="text-[11px] text-gray-500">Fill in the ledger account information below</span>
              </div>
            </div>

            <div className="flex flex-col gap-3 mt-1">
              {/* Ledger Name */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">
                  Ledger Name <span className="text-red-500">*</span>
                </label>
                <SherComboBox
                  id="lr_Name"
                  name="lr_Name"
                  comboRef={nameInputRef}
                  options={Lednames}
                  value={formData.ledcode || formData.lr_Name}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Name: label,
                      ledcode: value,
                    }))
                  }
                  onInputChange={(text) => {
                    const trimmed = text.trim();
                    const matched = Lednames.find(
                      (item) =>
                        item.label?.toLowerCase() === trimmed.toLowerCase() ||
                        item.value?.toString() === trimmed
                    );
                    if (matched) {
                      setFormData((prev) => ({
                        ...prev,
                        lr_Name: matched.label,
                        ledcode: matched.value,
                      }));
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        lr_Name: text,
                        ledcode: "",
                      }));
                    }
                  }}
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Name: text,
                      ledcode: "",
                    }))
                  }
                  showArrow={true}
                  clearable={false}
                  placeholder="Select or type ledger name..."
                  className="w-full h-[36px] outline-none"
                  inputClassName="rounded-[6px] border border-[#cbd5e1]"
                  onKeyDown={(e) => handleEnterNav(e, "lr_Name")}
                />
              </div>

              {/* Under (Group) */}
              <div className="flex flex-col gap-1 mt-2">
                <label className="text-[12px] font-bold text-gray-700">
                  Under (Group) <span className="text-red-500">*</span>
                </label>
                <SherComboBox
                  id="lr_Under"
                  name="lr_Under"
                  value={formData.lh_id || formData.lr_Under}
                  comboRef={underInputRef}
                  options={under}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Under: label,
                      lh_id: value,
                    }))
                  }
                  onInputChange={(text) => {
                    const trimmed = text.trim();
                    const matched = under.find(
                      (item) =>
                        item.label?.toLowerCase() === trimmed.toLowerCase() ||
                        item.value?.toString() === trimmed
                    );
                    if (matched) {
                      setFormData((prev) => ({
                        ...prev,
                        lr_Under: matched.label,
                        lh_id: matched.value,
                      }));
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        lr_Under: text,
                        lh_id: "",
                      }));
                    }
                  }}
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Under: text,
                      lh_id: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_Under")}
                  showArrow={true}
                  clearable={false}
                  placeholder="Select account group..."
                  className="w-full h-[36px] outline-none"
                  inputClassName="rounded-[6px] border border-[#cbd5e1]"
                />
              </div>
            </div>

            {/* Info Banner */}
            <div className="mt-3 bg-[#EEF2FF] border border-[#C7D2FE] rounded-lg p-3 flex gap-2.5 items-start">
              <div className="text-[#4338CA] shrink-0 mt-0.5">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
              </div>
              <p className="text-[11px] font-semibold text-[#4338CA] m-0 leading-snug">
                Select the correct group under which this ledger should be classified. This affects all financial reports.
              </p>
            </div>
          </div>
        )}

        {activeTab === "address" && (
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#0008a9] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </div>
              <div className="flex flex-col">
                <h2 className="text-sm font-bold text-gray-900 m-0">Address & Contact</h2>
                <span className="text-[11px] text-gray-500">Enter the address and contact details</span>
              </div>
            </div>

            <div className="flex flex-col gap-3.5 mt-1">
              {/* Address 1 */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Address 1</label>
                <input
                  type="text"
                  placeholder="Enter address line 1"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={add1InputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Address1")}
                  value={formData.lr_Address1}
                  onChange={(e) => setFormData({ ...formData, lr_Address1: e.target.value })}
                />
              </div>

              {/* Address 2 */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Address 2</label>
                <input
                  type="text"
                  placeholder="Enter address line 2"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={add2InputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Address2")}
                  value={formData.lr_Address2}
                  onChange={(e) => setFormData({ ...formData, lr_Address2: e.target.value })}
                />
              </div>

              {/* Address 3 */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Address 3</label>
                <input
                  type="text"
                  placeholder="Enter address line 3"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={add3InputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Address3")}
                  value={formData.lr_Address3}
                  onChange={(e) => setFormData({ ...formData, lr_Address3: e.target.value })}
                />
              </div>

              {/* Address 4 */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Address 4</label>
                <input
                  type="text"
                  placeholder="Street / Locality"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={add4InputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Address4")}
                  value={formData.lr_Address4}
                  onChange={(e) => setFormData({ ...formData, lr_Address4: e.target.value })}
                />
              </div>

              {/* PIN Code */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">PIN Code</label>
                <input
                  type="number"
                  placeholder="PIN Code"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={pincodeInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Pincode")}
                  value={formData.lr_Pincode}
                  onChange={(e) => setFormData({ ...formData, lr_Pincode: e.target.value })}
                />
              </div>

              {/* Area */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Area</label>
                <SherComboBox
                  id="lr_Area"
                  name="lr_Area"
                  comboRef={areaInputRef}
                  options={areaOptions}
                  value={formData.lr_AreaId || formData.lr_Area}
                  placeholder="Select area..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  creatable={true}
                  onCreateOption={(text) => handleCreateOtherRegOption(text, 'City')}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Area: label,
                      lr_AreaId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Area: text,
                      lr_AreaId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_Area")}
                />
              </div>

              {/* Route */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Route</label>
                <SherComboBox
                  id="lr_Route"
                  name="lr_Route"
                  comboRef={routeInputRef}
                  options={routeOptions}
                  value={formData.lr_RouteId || formData.lr_Route}
                  placeholder="Select route..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  creatable={true}
                  onCreateOption={(text) => handleCreateOtherRegOption(text, 'Route')}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Route: label,
                      lr_RouteId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Route: text,
                      lr_RouteId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_Route")}
                />
              </div>

              {/* State */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">State</label>
                <SherComboBox
                  id="lr_State"
                  name="lr_State"
                  comboRef={stateInputRef}
                  options={stateOptions}
                  value={formData.lr_State}
                  placeholder="Select state..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_State: label,
                      lr_StateCode: value,
                    }))
                  }
                  onFreeInput={(text) => {
                    const matchedState = stateOptions.find(opt => opt.label.toLowerCase() === text.toLowerCase());
                    setFormData((prev) => ({
                      ...prev,
                      lr_State: text,
                      lr_StateCode: matchedState ? matchedState.value : prev.lr_StateCode,
                    }));
                  }}
                  onKeyDown={(e) => handleEnterNav(e, "lr_State")}
                />
              </div>

              {/* State Code */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">State Code</label>
                <SherComboBox
                  id="lr_StateCode"
                  name="lr_StateCode"
                  comboRef={stateCodeInputRef}
                  options={stateCodeOptions}
                  value={formData.lr_StateCode}
                  placeholder="Select code..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ value }) => {
                    const matchedState = stateOptions.find(opt => opt.value === value);
                    setFormData((prev) => ({
                      ...prev,
                      lr_StateCode: value,
                      lr_State: matchedState ? matchedState.label : prev.lr_State,
                    }));
                  }}
                  onFreeInput={(text) => {
                    const matchedState = stateOptions.find(opt => opt.value === text);
                    setFormData((prev) => ({
                      ...prev,
                      lr_StateCode: text,
                      lr_State: matchedState ? matchedState.label : prev.lr_State,
                    }));
                  }}
                  onKeyDown={(e) => handleEnterNav(e, "lr_StateCode")}
                />
              </div>

              {/* Mobile No */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Mobile No</label>
                <div className="relative flex items-center w-full">
                  <input
                    type="number"
                    placeholder="Enter mobile number"
                    className="w-full h-[36px] pl-3 pr-12 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                    ref={mobInputRef}
                    onKeyDown={(e) => handleEnterNav(e, "lr_Mobile")}
                    value={formData.lr_Mobile}
                    onChange={(e) => setFormData({ ...formData, lr_Mobile: e.target.value })}
                  />
                  <button
                    type="button"
                    onClick={handleFindBymob}
                    className="absolute right-0 top-0 h-full w-[38px] flex items-center justify-center bg-[#f1f5f9] border-l border-[#cbd5e1] rounded-r-[6px] text-[#0008a9] hover:bg-slate-200 transition-colors"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                  </button>
                </div>
              </div>

              {/* Sales Man */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Sales Man</label>
                <SherComboBox
                  id="lr_Salesman"
                  name="lr_Salesman"
                  placeholder="Select salesman..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  value={formData.lr_SalesMan}
                  comboRef={salesmanInputRef}
                  options={employeeNames}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_SalesMan: label,
                      lr_empid: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_SalesMan: text,
                      lr_empid: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_SalesMan")}
                />
              </div>

              {/* PAN */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">PAN</label>
                <input
                  type="text"
                  placeholder="Enter PAN number"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={panInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Pan")}
                  value={formData.lr_Pan}
                  onChange={(e) => setFormData({ ...formData, lr_Pan: e.target.value })}
                />
              </div>

              {/* E-Mail */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">E-Mail</label>
                <input
                  type="email"
                  placeholder="Enter email address"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={emailInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Email")}
                  value={formData.lr_Email}
                  onChange={(e) => setFormData({ ...formData, lr_Email: e.target.value })}
                />
              </div>

              {/* GST No */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">GST No</label>
                <div className="relative flex items-center w-full">
                  <input
                    type="text"
                    placeholder="Enter GST number"
                    className="w-full h-[36px] pl-3 pr-12 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                    ref={gstInputRef}
                    onKeyDown={(e) => handleEnterNav(e, "lr_Gstno")}
                    value={formData.lr_Gstno}
                    onChange={(e) => setFormData({ ...formData, lr_Gstno: e.target.value })}
                  />
                  <button
                    type="button"
                    onClick={handleFindBygst}
                    className="absolute right-0 top-0 h-full w-[38px] flex items-center justify-center bg-[#f1f5f9] border-l border-[#cbd5e1] rounded-r-[6px] text-[#0008a9] hover:bg-slate-200 transition-colors"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                  </button>
                </div>
              </div>

              {/* Location */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Location</label>
                <SherComboBox
                  id="lr_Location"
                  name="lr_Location"
                  comboRef={locationInputRef}
                  options={locationOptions}
                  value={formData.lr_LocationId || formData.lr_Location}
                  placeholder="Select location..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Location: label,
                      lr_LocationId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_Location: text,
                      lr_LocationId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_Location")}
                />
              </div>

              {/* SubGroup */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">SubGroup</label>
                <SherComboBox
                  id="lr_SubGroup"
                  name="lr_SubGroup"
                  comboRef={subGroupInputRef}
                  options={subGroupOptions}
                  value={formData.lr_SubGroupId || formData.lr_SubGroup}
                  placeholder="Select subgroup..."
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_SubGroup: label,
                      lr_SubGroupId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_SubGroup: text,
                      lr_SubGroupId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_SubGroup")}
                />
              </div>

              {/* Order Day */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Order Day</label>
                <SherComboBox
                  id="lr_OrderDay"
                  name="lr_OrderDay"
                  comboRef={orderDayInputRef}
                  options={dayOptions}
                  value={formData.lr_OrderDateId || formData.lr_OrderDate}
                  placeholder="Select day"
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_OrderDate: label,
                      lr_OrderDateId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_OrderDate: text,
                      lr_OrderDateId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_OrderDay")}
                />
              </div>

              {/* Delivery Day */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Delivery Day</label>
                <SherComboBox
                  id="lr_DeliveryDay"
                  name="lr_DeliveryDay"
                  comboRef={deliveryDayInputRef}
                  options={dayOptions}
                  value={formData.lr_DeliveryDateId || formData.lr_DeliveryDate}
                  placeholder="Select day"
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_DeliveryDate: label,
                      lr_DeliveryDateId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_DeliveryDate: text,
                      lr_DeliveryDateId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_DeliveryDay")}
                />
              </div>

              {/* Sales Rate */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Sales Rate</label>
                <SherComboBox
                  id="lr_SalesRate"
                  name="lr_SalesRate"
                  comboRef={salesRateInputRef}
                  placeholder="Select rate structure..."
                  options={salesRateOptions}
                  value={formData.lr_SalesRateId || formData.lr_SalesRate}
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label, value }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_SalesRate: label,
                      lr_SalesRateId: value,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_SalesRate: text,
                      lr_SalesRateId: "",
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_SalesRate")}
                />
              </div>

              {/* Contact Person */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Contact Person</label>
                <input
                  type="text"
                  placeholder="Enter contact person"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={CpersonInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_Contactperson")}
                  value={formData.lr_Contactperson}
                  onChange={(e) => setFormData({ ...formData, lr_Contactperson: e.target.value })}
                />
              </div>

              {/* Second Name */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Second Name</label>
                <input
                  type="text"
                  placeholder="Enter second name"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={secondNameInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_SecondName")}
                  value={formData.lr_SecondName}
                  onChange={(e) => setFormData({ ...formData, lr_SecondName: e.target.value })}
                />
              </div>

              {/* Commission Per */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Commission %</label>
                <input
                  type="text"
                  placeholder="0.00"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={commissionInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_CommissionPer")}
                  value={formData.lr_CommissionPer}
                  onChange={(e) => setFormData({ ...formData, lr_CommissionPer: e.target.value })}
                />
              </div>

              {/* Credit Amount */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Credit Amount</label>
                <input
                  type="text"
                  placeholder="0.00"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={cAmountInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_CAmount")}
                  value={formData.lr_CAmount}
                  onChange={(e) => setFormData({ ...formData, lr_CAmount: e.target.value })}
                />
              </div>

              {/* Days */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Days</label>
                <input
                  type="text"
                  placeholder="0"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={cDaysInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_CDays")}
                  value={formData.lr_CDays}
                  onChange={(e) => setFormData({ ...formData, lr_CDays: e.target.value })}
                />
              </div>

              {/* Max Discount % */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Max Discount %</label>
                <input
                  type="text"
                  placeholder="0.00"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={maxDiscountInputRef}
                  onKeyDown={(e) => handleEnterNav(e, "lr_MaxDiscount")}
                  value={formData.lr_MaxDiscount}
                  onChange={(e) => setFormData({ ...formData, lr_MaxDiscount: e.target.value })}
                />
              </div>

              {/* Customer Nature */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">Customer Nature</label>
                <SherComboBox
                  id="lr_CustomerNature"
                  name="lr_CustomerNature"
                  comboRef={customerNatureInputRef}
                  options={customerNatureOptions}
                  value={formData.lr_CustomerNature}
                  placeholder="Select nature"
                  showArrow={true}
                  clearable={false}
                  inputWidth="100%"
                  inputHeight="36px"
                  inputClassName="border border-[#cbd5e1] rounded-[6px]"
                  inputStyle={{ fontSize: "12px", paddingLeft: "8px" }}
                  onSelect={({ label }) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_CustomerNature: label,
                    }))
                  }
                  onFreeInput={(text) =>
                    setFormData((prev) => ({
                      ...prev,
                      lr_CustomerNature: text,
                    }))
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_CustomerNature")}
                />
              </div>
            </div>
          </div>
        )}

        {activeTab === "openingbalance" && (
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#0008a9] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6A2.25 2.25 0 0 1 18.75 20.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9A2.25 2.25 0 0 0 18.75 6.75H5.25A2.25 2.25 0 0 0 3 9v3" />
                </svg>
              </div>
              <div className="flex flex-col">
                <h2 className="text-sm font-bold text-gray-900 m-0">Opening Balance</h2>
                <span className="text-[11px] text-gray-500">Set the initial balance and settings</span>
              </div>
            </div>

            {/* As On Date */}
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-bold text-gray-700">As on Date</label>
              <input
                type="date"
                min={minDate}
                max={maxDate}
                className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                ref={dateRef}
                value={formData.lr_date}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val && !isDateInFy(val)) {
                    alert("Date incompatible with financial year");
                    return;
                  }
                  setFormData({ ...formData, lr_date: val });
                }}
                onKeyDown={(e) => handleEnterNav(e, "lr_debit")}
              />
            </div>

            {/* Debit & Credit */}
            <div className="grid grid-cols-2 gap-4 mt-2">
              <div className="flex flex-col gap-1 bg-slate-50 p-2.5 rounded-lg border border-slate-100">
                <label className="text-[11px] font-bold text-[#0008a9] uppercase tracking-wider">Debit Amount</label>
                <input
                  type="number"
                  placeholder="0.000"
                  className="w-full h-[36px] px-2 text-right text-xs border border-gray-200 rounded-[6px] outline-none bg-white box-border"
                  style={{ width: "100%", margin: 0, boxSizing: "border-box" }}
                  value={formData.lr_debit}
                  ref={debitAmountInputRef}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      lr_debit: e.target.value,
                      lr_credit: "0.000",
                    })
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_debit")}
                />
              </div>

              <div className="flex flex-col gap-1 bg-slate-50 p-2.5 rounded-lg border border-slate-100">
                <label className="text-[11px] font-bold text-[#0008a9] uppercase tracking-wider">Credit Amount</label>
                <input
                  type="number"
                  placeholder="0.000"
                  className="w-full h-[36px] px-2 text-right text-xs border border-gray-200 rounded-[6px] outline-none bg-white box-border"
                  style={{ width: "100%", margin: 0, boxSizing: "border-box" }}
                  value={formData.lr_credit}
                  ref={creditAmountInputRef}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      lr_credit: e.target.value,
                      lr_debit: "0.000",
                    })
                  }
                  onKeyDown={(e) => handleEnterNav(e, "lr_credit")}
                />
              </div>
            </div>

            {/* Account Settings */}
            <div className="mt-4 border-t border-gray-100 pt-4">
              <span className="text-[11px] font-bold text-gray-500 uppercase tracking-wider block mb-3">Account Settings</span>
              <div className="flex flex-col gap-3">
                {accountSettings.map((setting) => (
                  <label key={setting.id} className="flex items-center gap-3 cursor-pointer group w-fit">
                    <input
                      type="checkbox"
                      checked={!!formData[setting.field]}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          [setting.field]: e.target.checked ? 1 : 0,
                        }))
                      }
                      className="w-4 h-4 rounded border-gray-300 text-blue-600 accent-[#0008a9]"
                    />
                    <span className="text-xs font-semibold text-gray-700">{setting.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === "msme" && (
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#0008a9] rounded-[8px] flex items-center justify-center text-white shrink-0 shadow-sm">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <div className="flex flex-col">
                <h2 className="text-sm font-bold text-gray-900 m-0">MSME Details</h2>
                <span className="text-[11px] text-gray-500">Enable and configure MSME details</span>
              </div>
            </div>

            {/* Enable MSME Checkbox */}
            <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={!!formData.lr_MsmeEnabled}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      lr_MsmeEnabled: e.target.checked ? 1 : 0,
                    })
                  }
                  className="w-4 h-4 mt-0.5 rounded border-gray-300 accent-[#0008a9]"
                />
                <div className="flex flex-col">
                  <span className="text-xs font-bold text-gray-700">Enable MSME for this Ledger</span>
                  <span className="text-[10px] text-gray-500 mt-0.5">Check this to fill in MSME registration details</span>
                </div>
              </label>
            </div>

            <div className="flex flex-col gap-3.5 mt-1">
              {/* Udyam No */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">MSME Udyam Registration No</label>
                <input
                  type="text"
                  placeholder="UDYAM-XX-00-0000000"
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border"
                  ref={msmeUdyamInputRef}
                  value={formData.lr_MsmeUdyamNo}
                  onChange={(e) => setFormData({ ...formData, lr_MsmeUdyamNo: e.target.value })}
                  onKeyDown={(e) => handleEnterNav(e, "lr_MsmeUdyamNo")}
                />
              </div>

              {/* MSME Types */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">MSME Types</label>
                <select
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border bg-white text-gray-700"
                  ref={msmeTypeInputRef}
                  value={formData.lr_MsmeType}
                  onChange={(e) => setFormData({ ...formData, lr_MsmeType: e.target.value })}
                  onKeyDown={(e) => handleEnterNav(e, "lr_MsmeType")}
                >
                  <option value="">Select MSME type</option>
                  <option value="None">None</option>
                  <option value="Micro">Micro</option>
                  <option value="Small">Small</option>
                  <option value="Medium">Medium</option>
                </select>
              </div>

              {/* MSME Agreement */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">MSME Agreement</label>
                <select
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border bg-white text-gray-700"
                  ref={msmeAgreementInputRef}
                  value={formData.lr_MsmeAgreement}
                  onChange={(e) => setFormData({ ...formData, lr_MsmeAgreement: e.target.value })}
                  onKeyDown={(e) => handleEnterNav(e, "lr_MsmeAgreement")}
                >
                  <option value="">Select agreement type</option>
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>

              {/* Business Type */}
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-bold text-gray-700">MSME Business Types</label>
                <select
                  className="w-full h-[36px] px-3 text-xs border border-[#cbd5e1] rounded-[6px] outline-none focus:border-[#0008a9] box-border bg-white text-gray-700"
                  ref={msmeBusinessTypeInputRef}
                  value={formData.lr_MsmeBusinessType}
                  onChange={(e) => setFormData({ ...formData, lr_MsmeBusinessType: e.target.value })}
                  onKeyDown={(e) => handleEnterNav(e, "lr_MsmeBusinessType")}
                >
                  <option value="">Select business type</option>
                  <option value="Not Specified">Not Specified</option>
                  <option value="Trader">Trader</option>
                  <option value="Manufacturer">Manufacturer</option>
                  <option value="Service">Service</option>
                </select>
              </div>
            </div>

            {/* Compliance Notice */}
            <div className="bg-[#EEF2FF] border border-[#C7D2FE] rounded-lg p-3 flex gap-2.5 items-start">
              <div className="text-[#4338CA] shrink-0 mt-0.5">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <p className="text-[11px] font-semibold text-[#4338CA] m-0 leading-snug">
                MSME details are required for compliance under the MSME Development Act. Ensure the Udyam Registration number is correct before saving.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Save Ledger Button */}
      <div className="p-4 bg-white border-t border-gray-100 flex-shrink-0 z-10">
        <button
          onClick={dataFound ? handleUpdate : handleSubmit}
          disabled={isLoading || (dataFound ? editDisabled : saveDisabled)}
          className="w-full py-3 bg-[#0008a9] text-white text-sm font-bold rounded-lg shadow-md hover:bg-blue-800 transition-colors disabled:opacity-50"
        >
          {isLoading ? "Processing..." : dataFound ? "Update Ledger" : "Save Ledger"}
        </button>
      </div>

      {showRenameLedModal && (
        <RenameLedger
          onClose={() => {
            setShowRenameLedModal(false);
            handleClear();
          }}
          LedName={formData.lr_Name}
        />
      )}
    </div>
  );
}

export default LedgerRegMob;
